import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Skeleton } from '@hh.ru/magritte-ui-skeleton';

var styles = {"switch":"magritte-switch___0AZYC_2-0-41","slider":"magritte-slider___YN62u_2-0-41","checked":"magritte-checked___QEAn5_2-0-41","switch-skeleton":"magritte-switch-skeleton___g1MEY_2-0-41","switchSkeleton":"magritte-switch-skeleton___g1MEY_2-0-41"};

const SwitchSkeleton = ({ Component: Switch, 
// skeleton props
width, height, borderRadius, inline, additionalClass, loading, ...switchProps }) => (jsx(Skeleton, { loading: loading, additionalClass: styles.switchSkeleton, inline: true, children: jsx(Switch, { ...switchProps }) }));

export { SwitchSkeleton as S, styles as s };
//# sourceMappingURL=Skeleton-CCWZ3lCQ.js.map
